<div *ngIf="pendingOrders.length > 0">
  <table mat-table [dataSource]="pendingOrders">
    <!-- Customer Name Column -->
    <ng-container matColumnDef="customerName">
      <th mat-header-cell *matHeaderCellDef> Customer Name </th>
      <td mat-cell *matCellDef="let order"> {{ order.customerName }} </td>
    </ng-container>

    <!-- Number of Items Column -->
    <ng-container matColumnDef="numberOfItems">
      <th mat-header-cell *matHeaderCellDef> Number of Items </th>
      <td mat-cell *matCellDef="let order"> {{ order.numberOfItems }} </td>
    </ng-container>

    <!-- Total Amount Column -->
    <ng-container matColumnDef="totalAmount">
      <th mat-header-cell *matHeaderCellDef> Total </th>
      <td mat-cell *matCellDef="let order"> {{ order.totalAmount | currency:'INR':'symbol' }} </td>
    </ng-container>

    <!-- Footer Row for Grand Total -->
    <ng-container matColumnDef="grandTotDesc">
      <td mat-footer-cell *matFooterCellDef colspan="2" class="grand-total">
        <strong>Grand Total</strong>
      </td>
    </ng-container>
    <ng-container matColumnDef="grandTotal">
      <td mat-footer-cell *matFooterCellDef class="grand-total">
        <strong>{{ grandTotal | currency:'INR':'symbol' }}</strong>
      </td>
    </ng-container>

    <!-- Header Row -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

    <!-- Data Row -->
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" (dblclick)="openOrder(row)"></tr>

    <!-- Footer Row (for grand total) -->
    <tr mat-footer-row *matFooterRowDef="footerColumns"></tr>

  </table>

  <!-- Sync Orders Button -->
  <div class="sync-button-container">
    <button mat-raised-button color="primary" (click)="syncOrders()">
      Sync Orders
    </button>
  </div>
</div>

<!-- No Pending Orders -->
<div *ngIf="pendingOrders.length === 0">
  <p>No pending orders found.</p>
</div>
